(function () {
  function initRoot(root) {
    var slides = root.querySelectorAll('[data-em-slide]');
    var thumbs = root.querySelectorAll('[data-em-thumb]');
    var lightbox = root.querySelector('[data-em-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-em-lightbox-img]') : null;

    var current = 0;

    function activate(index) {
      index = String(index);
      current = parseInt(index, 10) || 0;
      slides.forEach(function (slide) {
        var on = slide.getAttribute('data-em-slide') === index;
        slide.classList.toggle('is-active', on);
        var video = slide.querySelector('video');
        if (!video) return;
        if (on) {
          video.muted = true;
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-em-thumb') === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(thumb.getAttribute('data-em-thumb'));
      });
    });

    function step(dir) {
      var count = slides.length;
      if (!count) return;
      activate(String((current + dir + count) % count));
    }

    root.querySelectorAll('[data-em-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        step(parseInt(btn.getAttribute('data-em-nav'), 10) || 1);
      });
    });

    var stage = root.querySelector('.em-gallery__stage');
    if (stage && slides.length > 1) {
      var touchX = 0;
      var touchY = 0;
      var touchLive = false;

      stage.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) { touchLive = false; return; }
        touchX = event.touches[0].clientX;
        touchY = event.touches[0].clientY;
        touchLive = true;
      }, { passive: true });

      stage.addEventListener('touchend', function (event) {
        if (!touchLive) return;
        touchLive = false;
        var dx = event.changedTouches[0].clientX - touchX;
        var dy = event.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });

      stage.addEventListener('touchcancel', function () { touchLive = false; }, { passive: true });
    }

    root.querySelectorAll('.em-specs-link[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if (!lightbox || !lightboxImg) return;

    document.querySelectorAll('body > [data-em-lightbox]').forEach(function (old) { old.remove(); });
    document.body.appendChild(lightbox);

    var lbVideo = lightbox.querySelector('[data-em-lightbox-video]');
    var lbCount = lightbox.querySelector('[data-em-lb-count]');
    var lbIndex = -1;

    function resetZoom() {
      lightbox.classList.remove('is-zoomed');
      lightboxImg.style.transformOrigin = '';
    }

    function clearVideo() {
      if (!lbVideo) return;
      lbVideo.innerHTML = '';
      lbVideo.hidden = true;
    }

    function pauseGallery() {
      slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (video && !video.paused) video.pause();
      });
    }

    function showImage(src, alt) {
      clearVideo();
      lightboxImg.hidden = false;
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
    }

    function showSlide(index) {
      var count = slides.length;
      if (!count) return;
      lbIndex = (index + count) % count;
      var slide = slides[lbIndex];
      resetZoom();
      var media = slide.querySelector('video, iframe');
      var img = slide.querySelector('img[data-em-hd]') || slide.querySelector('img');
      if (media && lbVideo) {
        clearVideo();
        lightboxImg.hidden = true;
        lightboxImg.removeAttribute('src');
        var clone = media.cloneNode(true);
        clone.removeAttribute('class');
        if (clone.tagName === 'VIDEO') {
          clone.muted = true;
          clone.controls = true;
          clone.setAttribute('playsinline', '');
        }
        lbVideo.appendChild(clone);
        lbVideo.hidden = false;
        if (clone.tagName === 'VIDEO') {
          var playing = clone.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
      } else if (img) {
        showImage(img.getAttribute('data-em-hd') || img.currentSrc || img.src, img.getAttribute('alt'));
      }
      if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + count;
      activate(String(lbIndex));
      pauseGallery();
    }

    function openBox(single) {
      lightbox.classList.toggle('is-single', !!single);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function openSlide(index) {
      showSlide(index);
      openBox(slides.length < 2);
    }

    function open(src, alt) {
      lbIndex = -1;
      resetZoom();
      showImage(src, alt);
      openBox(true);
    }

    function close() {
      resetZoom();
      lightbox.classList.remove('is-open', 'is-single');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.removeAttribute('src');
      clearVideo();
      document.documentElement.style.overflow = '';
      if (lbIndex >= 0) activate(String(lbIndex));
      lbIndex = -1;
    }

    function lbStep(dir) {
      if (lbIndex < 0) return;
      showSlide(lbIndex + dir);
    }

    lightbox.querySelectorAll('[data-em-lb-nav]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        lbStep(parseInt(btn.getAttribute('data-em-lb-nav'), 10) || 1);
      });
    });

    var zoomBtn = root.querySelector('[data-em-zoom-btn]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        openSlide(current);
      });
    }

    root.querySelectorAll('[data-em-zoom]').forEach(function (img) {
      img.addEventListener('click', function () {
        open(img.getAttribute('data-em-zoom'), img.getAttribute('alt'));
      });
    });

    slides.forEach(function (slide, i) {
      var target = slide.querySelector('img[data-em-hd], video');
      if (!target) return;
      target.addEventListener('click', function () {
        openSlide(i);
      });
    });

    function aim(event) {
      var w = lightboxImg.offsetWidth;
      var h = lightboxImg.offsetHeight;
      if (!w || !h) return;
      var x = Math.min(100, Math.max(0, event.offsetX / w * 100));
      var y = Math.min(100, Math.max(0, event.offsetY / h * 100));
      lightboxImg.style.transformOrigin = x + '% ' + y + '%';
    }

    lightboxImg.addEventListener('pointermove', function (event) {
      if (lightbox.classList.contains('is-zoomed')) aim(event);
    });

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.closest('[data-em-close]')) close();
    });

    lightboxImg.addEventListener('click', function (event) {
      event.stopPropagation();
      if (!lightbox.classList.contains('is-zoomed')) aim(event);
      lightbox.classList.toggle('is-zoomed');
    });

    var lbTouchX = 0;
    var lbTouchY = 0;
    var lbTouchLive = false;

    lightbox.addEventListener('touchstart', function (event) {
      lbTouchLive = event.touches.length === 1 && !lightbox.classList.contains('is-zoomed');
      if (!lbTouchLive) return;
      lbTouchX = event.touches[0].clientX;
      lbTouchY = event.touches[0].clientY;
    }, { passive: true });

    lightbox.addEventListener('touchend', function (event) {
      if (!lbTouchLive) return;
      lbTouchLive = false;
      var dx = event.changedTouches[0].clientX - lbTouchX;
      var dy = event.changedTouches[0].clientY - lbTouchY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      lbStep(dx < 0 ? 1 : -1);
    }, { passive: true });

    document.addEventListener('keydown', function (event) {
      if (!lightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowRight') lbStep(1);
      else if (event.key === 'ArrowLeft') lbStep(-1);
    });
  }

  function init() {
    document.querySelectorAll('[data-em-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-em-root]');
    if (root) initRoot(root);
  });
})();
